import { generateApiPath } from "@routes/generatePath";

const pathBase = `/medical-service-provider/reports/assign-list/`;

export const medicalServiceAssign = {
  get: () => generateApiPath(pathBase),
};
